<script lang="ts" setup>
import { computed } from 'vue';

import { MoneyFormatter } from '@apps/main/new-desktop/core/components/formatters';

import type { Money } from '@libs/trip-planner-interfaces';

interface AccommodationPriceProps {
  price: Money;
}

const props = defineProps<AccommodationPriceProps>();

const deltaPriceClass = computed<string>(() => {
  if (props.price.amount > 0) {
    return 'positive';
  }
  if (props.price.amount < 0) {
    return 'negative';
  }
  return 'zero';
});
</script>

<template>
  <div :class="['accommodation-price', deltaPriceClass]">
    <MoneyFormatter
      :data="{
        minPrice: undefined,
        price: props.price.amount,
        showPlusMinusMark: true,
        color: 'color-secondary-40',
      }"
    />
  </div>
</template>

<style lang="scss" scoped>
.accommodation-price {
  @include font-label-l-bold;
  padding: var(--spacing-8) var(--spacing-12);
  border-radius: var(--spacing-8);
  background-color: var(--color-primary-90);
  line-height: var(--line-heights-14);

  &.positive {
    background-color: var(--color-brand-sky);
  }

  &.negative {
    background-color: #bde8d9;
  }
}
</style>
